<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapActions, mapGetters } from "vuex";
import PageAlerts from "@/components/page-alerts";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Income Statement",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    PageAlerts,
  },
  data() {
    return {
      title: "Income Statement",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Income Statement",
          active: true,
        },
      ],
      data: {
        year: "",
        month: "",
        type: "income",
      },
    };
  },
  computed: {
    ...mapGetters("auth", ["getCurrentUser"]),
    ...mapGetters("accounts", ["getIncomeState", "SaveStatus"]),
    ...mapGetters("marks", ["getYears"]),
  },
  watch: {
    // getSuccessConfirm(newValue) {
    //   if (newValue == true) {
    //   }
    // },
  },
  methods: {
    ...mapActions({
      FetchYears: "marks/fetchYear",
      FetchIncomeState: "accounts/fetchIncomeState",
      PrintIncomeStateDoc: "accounts/printIncomeStateDoc",
    }),
    // COMMA SEPERTOR FUNCTION
    thousandSeperater(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        const new_m = m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return m < 0 ? `-${new_m}` : new_m;
      } else {
        return m;
      }
    },
    fetchIncomeStateDoc() {
      this.getIncomeState.year = this.data.year;
      this.PrintIncomeStateDoc(this.getIncomeState);
    },
    fetchincomestatement() {
      this.FetchIncomeState(this.data);
    },
    getCurrentYear() {
      const currentDate = new Date();
      this.data.year = currentDate.getFullYear();
      this.data.month = currentDate.toLocaleString("default", {
        month: "long",
      });
      this.FetchIncomeState(this.data);
    },
  },
  created() {
    this.FetchYears();
    this.getCurrentYear();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div
      class="row"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('setting_sms')
        )
      "
    >
      <div class="col-12">
        <div class="card">
          <div class="card-body row">
            <div class="form-group col-md-12 row">
              <div class="form-group col-md-2">
                <label for="">Year <small class="text-danger">*</small></label>
                <select
                  class="form-control form-control-sm"
                  required
                  v-model="data.year"
                  @change="fetchbalancesht()"
                >
                  <option value="" selected disabled>Select Year</option>
                  <option
                    v-for="(schyear, index) in getYears"
                    :value="schyear.year"
                    :key="index"
                  >
                    {{ schyear.year }}
                  </option>
                </select>
              </div>
              <div class="col-md-10">
                <b-button-group class="mb-2 float-end">
                  <button
                    v-if="SaveStatus"
                    disabled
                    class="btn btn-sm btn-secondary"
                  >
                    <b-spinner
                      variant="white"
                      small
                      label="Retrieving..."
                    ></b-spinner>
                    Retrieving...
                  </button>
                  <button
                    v-else
                    @click="fetchIncomeStateDoc()"
                    class="btn btn-sm btn-secondary"
                  >
                    <i class="fa fa-print"></i>
                    Print PDF
                  </button>
                </b-button-group>
              </div>
            </div>
            <div class="col-md-12 mt-4">
              <b-tabs content-class="p-3 text-muted">
                <b-tab>
                  <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                      <i class="far fa-user"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">
                      <i class="fa fa-cube" aria-hidden="true"></i>
                      {{ data.year }} Income Statement
                    </span>
                  </template>
                  <div class="row col-md-12">
                    <strong class="mb-2">
                      Income Statement for Year
                    </strong>
                    <hr />
                    <div role="tablist" v-if="getIncomeState">
                      <b-card no-body class="shadow-none">
                        <div class="row d-flex">
                          <div class="col-md-11 row d-flex mx-auto px-4">
                            <div class="col-md-12 mt-3 mx-auto">
                              <table class="table">
                                <!-- Schools Assets  -->
                                <thead>
                                  <tr>
                                    <th scope="col">
                                      <span
                                        class="text-primary"
                                        style="font-size: 15px"
                                      >
                                        REVENUE
                                      </span>
                                    </th>
                                    <th scope="col">
                                      Amount (UGX)
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr
                                    v-for="(revenues,
                                    index) in getIncomeState.revenueAccounts"
                                    :key="index"
                                    class="text-muted"
                                  >
                                    <td>{{ revenues.parent_name }}</td>
                                    <td>
                                      {{
                                        thousandSeperater(revenues.total_amount)
                                      }}
                                    </td>
                                  </tr>
                                </tbody>
                                <thead>
                                  <tr style="border-bottom: none">
                                    <th style="border-bottom: none">
                                      Total Revenue
                                    </th>
                                    <th style="border-bottom: none">
                                      {{
                                        thousandSeperater(
                                          getIncomeState.rev_totals
                                        )
                                      }}
                                    </th>
                                  </tr>
                                </thead>

                                <!-- School expenses -->
                                <thead>
                                  <tr>
                                    <th
                                      scope="col"
                                      style="width: 30rem"
                                      colspan="4"
                                    >
                                      <span
                                        class="mt-4 text-danger"
                                        style="font-size: 15px"
                                      >
                                        EXPENSES (UGX)
                                      </span>
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr
                                    v-for="(expenses,
                                    index1) in getIncomeState.expenseAccounts"
                                    :key="index1"
                                    class="text-muted"
                                  >
                                    <td>{{ expenses.parent_name }}</td>
                                    <td>
                                      {{
                                        thousandSeperater(expenses.total_amount)
                                      }}
                                    </td>
                                  </tr>
                                </tbody>
                                <thead>
                                  <tr style="border-bottom: none">
                                    <th style="border-bottom: none">
                                      Total Expenses
                                    </th>
                                    <th style="border-bottom: none">
                                      {{
                                        thousandSeperater(
                                          getIncomeState.exp_totals
                                        )
                                      }}
                                    </th>
                                  </tr>
                                </thead>

                                <!-- Net Profits -->
                                <thead>
                                  <tr>
                                    <th scope="col">
                                      <span
                                        class="mt-5 text-success"
                                        style="font-size: 15px"
                                      >
                                        NET PROFITS
                                      </span>
                                    </th>
                                    <th scope="col">
                                      <u
                                        class="mt-4 text-success"
                                        style="font-size: 15px"
                                        v-if="
                                          parseInt(getIncomeState.rev_totals) -
                                            parseInt(
                                              getIncomeState.exp_totals
                                            ) >=
                                            0
                                        "
                                      >
                                        {{
                                          thousandSeperater(
                                            parseInt(
                                              getIncomeState.rev_totals
                                            ) -
                                              parseInt(
                                                getIncomeState.exp_totals
                                              )
                                          )
                                        }}
                                        UGX
                                      </u>
                                      <u
                                        class="mt-4 text-success"
                                        style="font-size: 15px"
                                        v-else
                                      >
                                        ({{
                                          thousandSeperater(
                                            Math.abs(
                                              parseInt(
                                                getIncomeState.rev_totals
                                              ) -
                                                parseInt(
                                                  getIncomeState.exp_totals
                                                )
                                            )
                                          )
                                        }}
                                        UGX)
                                      </u>
                                    </th>
                                  </tr>
                                </thead>
                              </table>
                            </div>
                          </div>
                        </div>
                      </b-card>
                    </div>
                    <!-- <PageAlerts
                      v-else-if="SaveStatus"
                      title="Please wait"
                      primaryMsg="Loading income statement sheet data..."
                      alertType="default"
                    /> -->
                    <PageAlerts
                      v-else
                      title="No data found"
                      primaryMsg="No transactions found for Income Statement."
                      alertType="default"
                    />
                  </div>
                </b-tab>
              </b-tabs>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row d-flex" v-else>
      <div class="col-md-8 mx-auto">
        <div class="jumbotron py-5 text-center">
          <strong class="display-6 text-danger">
            Access Denied <i class="fa fa-exclamation" aria-hidden="true"></i
          ></strong>
          <p class="lead text-muted py-4">
            Request For Permission From Administrator
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>
